import { Validation } from '../../services/model-service';
import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface ValidateEventArgs {
  entry?: string;
  valid: boolean;
  validations: Validation[];
}

class ValidateEvent extends EventData<Validatable> implements ValidateEventArgs {

  entry?: string;
  valid: boolean;
  validations: Validation[];

  constructor({ entry, valid, validations }: ValidateEventArgs) {
    super();
    this.entry = entry;
    this.valid = valid;
    this.validations = validations;
  }

}

class ValidateEventListener extends EventListener<Validatable, ValidateEvent, ValidateEventArgs> {

  constructor() {
    super(ValidateEvent);
  }

}

export default interface Validatable extends Mountable {
  /** @event */
  onValidate: ValidateEventListener;

  validate(): boolean;

  isValid(): boolean;
}

export { ValidateEventListener, ValidateEvent };
